import {LogLevel} from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "aba4219a-7482-47da-a20a-05ba4ed0c651",
        authority: "https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb",
    },
    // cache: {
    //     cacheLocation: "sessionStorage", // This configures where your cache will be stored
    //     storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    // },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        console.log(message);
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: ["openid", "profile", "user.read"],
};

export const appRoles = {
    User: "Dashboard.Read",
    Admin: "Dashboard.Admin",
}